module.exports = "/assets/data/2c1e14dbe1fb7b0bcbe381608a25c4de-M41.data.json";